import {h} from 'ui/Framework';

export default h('svg', {
  xmlns: 'http://www.w3.org/2000/svg',
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: '#FFF'
}, [
  h('path', {
    d: 'M23.5 24H.5c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h23c.3 0 .5.2.5.5s-.2.5-.5.5z'
  }),
  h('path', {
    d: 'M21.5 24h-19c-.3 0-.5-.2-.5-.5v-19c0-.3.2-.5.5-.5h19c.3 0 .5.2.5.5v19c0 .3-.2.5-.5.5zM3 23h18V5H3v18z'
  }),
  h('path', {
    d: 'M23.5 5H.5C.2 5 0 4.8 0 4.5S.2 4 .5 4h23c.3 0 .5.2.5.5s-.2.5-.5.5z'
  }),
  h('path', {
    d: 'M20.5 5h-17c-.3 0-.5-.2-.5-.5v-2c0-.3.2-.5.5-.5h17c.3 0 .5.2.5.5v2c0 .3-.2.5-.5.5zM4 4h16V3H4v1z'
  }),
  h('path', {
    d: 'M14.5 3h-5c-.3 0-.5-.2-.5-.5v-2c0-.3.2-.5.5-.5h5c.3 0 .5.2.5.5v2c0 .3-.2.5-.5.5zM10 2h4V1h-4v1zM13.5 24h-3c-.3 0-.5-.2-.5-.5v-4c0-.3.2-.5.5-.5h3c.3 0 .5.2.5.5v4c0 .3-.2.5-.5.5zM11 23h2v-3h-2v3zM8.5 21h-3c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h3c.3 0 .5.2.5.5s-.2.5-.5.5zM18.5 21h-3c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h3c.3 0 .5.2.5.5s-.2.5-.5.5zM10.5 17h-5c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h5c.3 0 .5.2.5.5s-.2.5-.5.5zM18.5 17h-5c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h5c.3 0 .5.2.5.5s-.2.5-.5.5zM10.5 14h-5c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h5c.3 0 .5.2.5.5s-.2.5-.5.5zM18.5 14h-5c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h5c.3 0 .5.2.5.5s-.2.5-.5.5zM10.5 11h-5c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h5c.3 0 .5.2.5.5s-.2.5-.5.5zM18.5 11h-5c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h5c.3 0 .5.2.5.5s-.2.5-.5.5zM10.5 8h-5c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h5c.3 0 .5.2.5.5s-.2.5-.5.5zM18.5 8h-5c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h5c.3 0 .5.2.5.5s-.2.5-.5.5z'
  })
]);



// WEBPACK FOOTER //
// ./src/javascripts/svg/nav-organization-information.es6.js